import { provideHttpClient } from '@angular/common/http';
import { Route } from '@angular/router';
import { LoginApi } from './services/login-api';

export const LOGIN_ROUTE: Route = {
  path: 'login',
  providers: [provideHttpClient(), LoginApi],
  loadComponent: () => import('./screens/login').then((m) => m.Login),
};
